import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoice } from 'src/app/Validators/Validators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-fa-question-submit-for-review',
  templateUrl: './question-submit-for-review.component.html',
  styleUrls: ['./question-submit-for-review.component.css'],
})
export class QuestionSubmitForReviewComponent implements OnInit {
  @Input() subjectById: any;
  @Input() Questionstatus: any;
  @Input() selectedQuestionById: any;
  @Input() EditQuestionFlag: boolean;
  @Output() CloseEditQuestion: EventEmitter<any> = new EventEmitter<any>();
  @Output() Questionreviewclose: EventEmitter<any> = new EventEmitter<any>();
  @Output() ReturnQuestionreviewclose: EventEmitter<any> =
    new EventEmitter<any>();

  @Input() ScreenName1: string;

  InsertQuestionStatus: QuestionStatusModel;
  AddQuestionStatusform: FormGroup;
  constructor(
    public service: QuestionManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}
  InitializeForm() {
    this.AddQuestionStatusform = this.fb.group({
      Question_ID: [''],
      Comment_Text: [''],
    });
  }

  ngOnInit() {
    this.InitializeForm();
    console.log(this.subjectById);
    console.log(this.selectedQuestionById);
    console.log(this.Questionstatus);
    this.getCode();
    this.getBreadcrumbDetails();
    this.GetQuestionStatusByID(this.selectedQuestionById.Question_Status_ID);
    this.Descriptioncount();
    this.service.ScreenTrackName = 'app-fa-question-submit-for-review';
  }

  QuestionStatusList: any;
  Question: any;
  GetQuestionStatusByID(data: any) {
    this.service
      .GetQuestionStatusByID({
        QuestionStatusID: data,
        IncludeReasonNotSelectedInd: 'N',
      })
      .subscribe(
        (i: any) => {
          this.Question = i;
          this.QuestionStatusList = this.Question.QuestionStatusList;
          if (this.QuestionStatusList.length > 0) {
            if (this.QuestionStatusList[0].Question_ID != null) {
              this.AddQuestionStatusform.controls['Question_ID'].setValue(
                this.QuestionStatusList[0].Question_ID
              );
            }
          }

          // this.selectedQuestionList.map((obj) => {
          // obj.checkedflag = false;
          // return obj;
          // })
          // }).catch((e:any)=>{
          //   this.QuestionStatusList=null;
          // });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getcodes: any;
  TableName: any;
  getCode() {
    if (this.Questionstatus == 'Defer') {
      this.TableName = 'QUESTION_DEFER_REASON_TYPE';
    } else if (this.Questionstatus == 'Rework') {
      this.TableName = 'QUESTION_REWORK_REASON_TYPE';
    } else if (this.Questionstatus == 'Rejected') {
      this.TableName = 'QUESTION_REJECTED_REASON_TYPE';
    } else {
      this.TableName = this.Questionstatus;
    }
    this.service.GetCode({ Tablename: this.TableName }).subscribe(
      (i: any) => {
        this.getcodes = i;
        if (this.getcodes != null) {
          this.getcodes.map((obj: { checkedflag: boolean }) => {
            obj.checkedflag = false;
            return obj;
          });
        }

        // }).catch((e:any)=>{
        //   this.getcodes=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  selectevent(data: any) {
    this.eventCheck(data.target);
  }

  save_submitted: boolean = false;
  QuestionQuestionResponse: any;
  Modalclose: boolean;
  ReviewReasons: any;
  AddQuestionStatus() {
    this.checkboxvalidation();
    if (!this.error1.isError) {
      this.InsertQuestionStatus = this.AddQuestionStatusform.value;
      this.InsertQuestionStatus.Question_Status_ID =
        this.QuestionStatusList[0].Question_Status_ID;
      this.InsertQuestionStatus.Question_Status_Type_Code = this.Questionstatus;
      if (this.getcodes != null) {
        let UDTReason: any[] = [];
        this.ReviewReasons = this.getcodes.filter(
          (item: { checkedflag: boolean }) => item.checkedflag == true
        );
        this.ReviewReasons.forEach((element: { Code: any }) => {
          let list: any = {};
          list['ReviewActionReasonTypeCode'] = element.Code;
          UDTReason.push(list);
        });
        this.InsertQuestionStatus.UDTQuestionReviewActionReason = UDTReason;
      }
      //  else{
      //   let UDTReason = [];
      //   let list: any = {};
      //   list["ReviewActionReasonTypeCode"] = 'DifficultyLevel';
      //   UDTReason.push(list);
      //   this.InsertQuestionStatus.UDTQuestionReviewActionReason=UDTReason;
      //  }
      this.service
        .CreateOrModifyQuestionStatus(this.InsertQuestionStatus)
        .subscribe(
          (i: any) => {
            this.QuestionQuestionResponse = i;
            if (this.QuestionQuestionResponse.Message == 'Success') {
                    this.toastr.success('Saved Successfully', 'Success',{timeOut: 500});
              this.save_submitted = false;
              // if(this.QuestionQuestionResponse.Value!=null&&this.QuestionQuestionResponse.Value!=""){
              //   this.getQuestionByID(this.AddQuestionResponse.Value);
              // }
              // else{
              //   this.getQuestionByID(this.AddQuestionform.controls['Question_ID'].value);
              // }
              //if(this.EditQuestionFlag){
              this.Questionreviewclose.emit(this.Modalclose);
              this.CloseEditQuestion.emit(this.Modalclose);
              //}
              //
            } else {
              this.toastr.error(this.QuestionQuestionResponse.Message);
            }
            //  }).catch((e:any)=>{
            //    this.QuestionQuestionResponse=e;
            //    this.toastr.error(this.QuestionQuestionResponse.statusText);
            //    this.save_submitted=false;

            //  }
            //  )
          },
          (error) => {
            this.QuestionQuestionResponse = error;
            this.toastr.error(this.QuestionQuestionResponse.statusText);
            this.save_submitted = false;
            console.log(error);
          }
        );
    }
  }

  eventCheck(data: any) {
    if (this.getcodes != null) {
      for (let item of this.getcodes) {
        if (item.Code == data.value) {
          if (item.checkedflag) {
            item.checkedflag = false;
          } else {
            item.checkedflag = true;
          }
        }
      }
      this.checkboxvalidation();
    }
  }

  error1: any = { isError: false, errorMessage: '' };
  check: boolean = false;
  checkboxvalidation() {
    if (this.getcodes != null) {
      this.check = false;
      for (let item of this.getcodes) {
        if (item.checkedflag) {
          this.check = true;
          break;
        }
      }
      if (this.check) this.error1 = { isError: false, errorMessage: '' };
      else
        this.error1 = {
          isError: true,
          errorMessage: 'Select at least one Reason',
        };
    }
  }

  Breadcrumblist: any;
  getBreadcrumbDetails() {
    this.service
      .getBreadcrumbDetails({ ID: this.subjectById.Subject_Id })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          //  }).catch((e: any) => {
          //    this.subjectById = null;
          //  }
          //  )
        },
        (error) => {
          console.log(error);
        }
      );
  }

  Cancel() {
    this.ReturnQuestionreviewclose.emit(this.Modalclose);
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  Descriptioncount() {
    this.DescriptionMaxlength = 4000;
    if (
      this.AddQuestionStatusform.controls.Comment_Text.value != '' &&
      this.AddQuestionStatusform.controls.Comment_Text.value != null
    ) {
      if (this.AddQuestionStatusform.controls.Comment_Text.value.length > 0) {
        this.Descriptionvaluelength =
          this.AddQuestionStatusform.controls.Comment_Text.value.length;
      } else {
        this.Descriptionvaluelength = 0;
      }
    } else {
      this.Descriptionvaluelength = 0;
    }
  }
}
